import React from "react";
import './kcontact.css';

function KContact() {
    return (
        <section id="contact-2251">
            <div className="cs-container">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2920.9431774195914!2d-87.9487112239607!3d42.93732477114517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880511442f4f3643%3A0xd7e969278e5356d4!2sShri%20Radha%20Madhav%20Temple!5e0!3m2!1sen!2sus!4v1746500919057!5m2!1sen!2sus" width="600" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>               
             <div className="cs-wrapper">
                    <div className="cs-content">
                        <span className="cs-topper">Contact Us</span>
                        <h2 className="cs-title">Let's Capture The Celebration of True Love</h2>
                        <p className="cs-text">
                            Curious about the Temple or looking to get involved? Our doors are open to everyone—come be part of our growing community.
                        </p>
                        <p className="cs-text">
                        <br /><br />Whether you have questions about our events, want to volunteer, or simply wish to learn more about Krishna consciousness, we're here to help. 
                            <br /><br />Reach out to us through the Phone number by giving us a call or Visit the location address. We look forward to connecting with you!
                        </p>
                    </div>
                    <div>
                        <p className="cs-text">
                            <strong>Address</strong>: 2419, W RAMSAY AVE, MILWAUKEE, WI, USA 53221 <br /><br />
                            <strong>Phone</strong>: 414-763-2785 | 414-204-9322
                        </p>
                    </div>
                    {/* <form className="cs-form" id="cs-form-2251" name="Contact Form" method="post">
                        <label className="cs-label">
                            <input className="cs-input" required type="text" id="name-2251" name="name" placeholder="Name"></input>
                        </label>
                        <label className="cs-label">
                            <input className="cs-input" required type="email" id="email-2251" name="email" placeholder="Email"></input>
                        </label>
                        <label className="cs-label">
                            <input className="cs-input" type="tel" id="phone-2251" name="phone" placeholder="Phone"></input>
                        </label>
                        <label className="cs-label">
                            <select className="cs-select" name="class" id="classes-2251">
                                <option value="Service 1">Services</option>
                                <option value="Service 2">Services</option>
                                <option value="Service 3">Services</option>
                                <option value="Service 4">Services</option>
                            </select>
                        </label>
                        <label className="cs-label cs-message">
                            <textarea className="cs-input cs-textarea" required name="Message" id="message-2251" placeholder="Message"></textarea>
                        </label>
                        <div className="cs-button-wrapper">
                            <button className="cs-button-solid cs-submit" type="submit">Schedule Consultation</button>
                        </div>
                    </form> */}
                </div>
            </div>
        </section>
        )                    
}
export default KContact;